import React from 'react';
import ContextProvider from './src/store/store';
import './main.css';
import './fonts.css';
// import '@fontsource/inter';
// import '@fontsource/inter/500.css';
// import '@fontsource/inter/600.css';
// import '@fontsource/inter/800.css';

export const wrapRootElement = ({ element }) => {
  return <ContextProvider>{element}</ContextProvider>;
};
